import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Clothing = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 28H11C9.35 28 8 26.65 8 25V18H7C5.35 18 4 16.65 4 15V10.162C4 8.43702 4.8 6.83702 6.25 5.66202C7.55 4.61202 9.287 3.99902 11 3.99902C11.475 3.99902 11.875 4.32402 11.975 4.78702C12 4.91202 12.75 8.00002 16 8.00002C19.25 8.00002 20 4.91202 20.025 4.77502C20.125 4.32502 20.537 4.00002 21 4.00002C22.725 4.00002 24.462 4.58802 25.75 5.61202C27.2 6.76202 28 8.38702 28 10.162V15C28 16.65 26.65 18 25 18H24V25C24 26.65 22.65 28 21 28ZM10 17V25C10 25.55 10.45 26 11 26H21C21.55 26 22 25.55 22 25V15C22 14.45 22.45 14 23 14C23.55 14 24 14.45 24 15V16H25C25.55 16 26 15.55 26 15V10.162C26 8.27502 24.413 6.33702 21.725 6.03702C21.05 7.73702 19.312 10 16 10C12.688 10 10.95 7.73702 10.287 6.05002C8.099 6.33702 6 7.91202 6 10.162V15C6 15.55 6.45 16 7 16H8V15C8 14.45 8.45 14 9 14C9.55 14 10 14.45 10 15V17Z" />
	</svg>
);

export default Clothing;
